import { Sets } from './Sets';

export abstract class Gets extends Sets
{
	
}